import { Translation } from 'primeng/api';
import { logout } from '../auth/store/auth.actions';
import { createReducer, on } from '@ngrx/store';
import { setDataDarkMode, setDataSidebarCollapsed, setDataTranslations } from './data.actions';
import { hydrateSuccess } from './storage.actions';

export const DATA_FEATURE_KEY = 'data';

export interface DataState {
  darkMode: boolean;
  sidebarCollapsed: boolean;
  translations: Translation[] | null;
}

export const initialState: DataState = {
  darkMode: false,
  sidebarCollapsed: false,
  translations: null,
};

export const dataReducer = createReducer(
  initialState,
  on(setDataDarkMode, (state, payload) => ({ ...state, darkMode: payload.darkMode })),
  on(setDataSidebarCollapsed, (state, payload) => ({ ...state, sidebarCollapsed: payload.sidebarCollapsed })),
  on(setDataTranslations, (state, payload) => ({ ...state, translations: payload.translations })),
  on(hydrateSuccess, (state, payload) => ({ ...state, ...payload.state.data })),
  on(logout, (state) => ({ ...initialState, darkMode: state.darkMode, sidebarCollapsed: state.sidebarCollapsed })),
);
